import type {DateRangeValue} from '@date-picker';

import {dateToReadableDate, RangeCalendar} from '@date-picker';

type CouponDateRangeProps = {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
};

const CouponDateRange: React.FC<CouponDateRangeProps> = ({value, onChange}) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col justify-between overflow-hidden">
      <RangeCalendar onChange={onChange} value={value} numberOfMonths={2} disableToday />
      <div className="flex border-t border-gray-22 px-4 py-3">
        <div className="flex-1">
          <span className="text-body-xs text-gray-34">تاریخ شروع</span>
          <p className="mt-2 text-subtitle-md text-neutral-fg">
            {value.start
              ? dateToReadableDate({date: value.start, day: true, month: true, year: true})
              : '-'}
          </p>
        </div>
        <div className="flex-1">
          <span className="text-body-xs text-gray-34">تاریخ پایان</span>
          <p className="mt-2 text-subtitle-md text-neutral-fg">
            {value.end
              ? dateToReadableDate({date: value.end, day: true, month: true, year: true})
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponDateRange;
